import DangerZone from "./DangerZone";
import PersonalInfo from "./PersonalInfo";
import Preferences from "./Preferences";
import UploadAvatar from "./UploadAvatar";

const accountComponents = {
  DangerZone,
  PersonalInfo,
  Preferences,
  UploadAvatar
}

export default accountComponents